// ------------------------------------
// Formulários AJAX
// ------------------------------------
(function () {
  'use strict';

  const $forms = $('.form-ajax');

  $forms.each(function () {
    // Variáveis
    const $form = $(this);
    const $btn = $form.find('button[type="submit"]');
    const url = $form.attr('action');
    const type = $form.attr('method');
    const btnText = $btn.html();
    const reset = $form.data('reset');
    const acao = $form.data('acao');
    const modal = $form.data('modal');
    let enviando = false;

    // Retorna o formulário ao estado inicial
    function resetForm(clearForm = false) {
      enviando = false;
      $btn.prop('disabled', false).removeClass('btn-loader').html(btnText);
      if (clearForm && reset) {
        $form[0].reset();
        $form.parsley().reset();
      }
    }

    // Ações executadas antes e enquanto o formulário é processado
    function sendingForm() {
      enviando = true;
      $btn.prop('disabled', true).addClass('btn-loader').text('Aguarde');
    }

    // Sucesso
    function successForm(resp) {
      console.log(resp);
      resp = JSON.parse(resp);
      if (resp.status === 'success') {
        // Fecha o modal
        if (modal) {
          modalClose(modal);
        }
        resetForm(reset);
        // Recarrega a página
        if (acao === 'reload') {
          location.reload();
        }
        // Redireciona
        else if (acao === 'retorno') {
          const retornoUrl = $form.find('input[name="retorno"]').val();
          location.href = retornoUrl;
        }
        // Exibe mensagem
        else {
          setTimeout(() => {
            showAlert('Sucesso', resp.message, 'success');
          }, 500);
        }
      } else {
        resetForm();
        showAlert('Erro', resp.message, 'danger');
      }
    }

    // Erro
    function errorForm(xhr, status, exception) {
      console.log(exception);
      resetForm();
      showAlert('Erro', 'Não foi possível realizar esta operação.', 'danger');
    }

    // Envia o formulário
    $form.on('submit', function (ev) {
      ev.preventDefault();
      const dados = new FormData(this);
      if (!enviando) {
        console.log($form.attr('id'));
        sendingForm();
        $.ajax({
          url: url,
          type: type,
          data: dados,
          contentType: false,
          cache: false,
          processData: false,
        })
          .done(successForm)
          .fail(errorForm);
      }
    });
  });
})();
